import { OrdersResponse } from '@/types/CataloguePage.types';

import { carmaCsrAuthClient } from './instance/carmaCsrAuthClient';

export const getOrdersIgnoreError = () =>
  carmaCsrAuthClient
    .get<OrdersResponse[]>('me/orders')
    .json()
    .catch((_error) => null);
